import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Pencil, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const CrudActions = ({ id, onEdit, onDelete }) => (
  <div className="flex justify-end gap-1">
    <Button size="icon" variant="ghost" data-testid={`edit-${id}`} onClick={onEdit}><Pencil className="h-4 w-4" /></Button>
    <Button size="icon" variant="ghost" data-testid={`delete-${id}`} onClick={onDelete} className="text-red-600 hover:bg-red-50 hover:text-red-700"><Trash2 className="h-4 w-4" /></Button>
  </div>
);

export const AddButton = ({ onClick, label, testId }) => (
  <Button data-testid={testId} onClick={onClick} className="rounded-xl bg-orange-600 hover:bg-orange-700 active:scale-95 transition-transform">
    <Plus className="mr-1 h-4 w-4" /> {label}
  </Button>
);

export async function confirmDelete(url, reload, label = "data") {
  if (!window.confirm(`Hapus ${label} ini?`)) return;
  try {
    await api.delete(url);
    toast.success("Berhasil dihapus");
    reload();
  } catch (e) {
    toast.error(errMsg(e));
  }
}

export function FormDialog({ open, onOpenChange, title, onSubmit, children, testId }) {
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await onSubmit();
      onOpenChange(false);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid={testId}>
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {children}
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid="form-save-btn" className="bg-orange-600 hover:bg-orange-700">{busy ? "Menyimpan..." : "Simpan"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export const Field = ({ label, children }) => (
  <div className="space-y-1.5"><Label>{label}</Label>{children}</div>
);

export const TextField = ({ label, testId, ...props }) => (
  <Field label={label}><Input data-testid={testId} {...props} /></Field>
);
